import { atom } from 'jotai';
import { Monster, Silage } from 'types/monster';

export const monsters = atom<Monster[]>([]);
export const silages = atom<Silage[]>([]);
